import { translate } from '@vimeo/i18n-runtime';

import PasswordForm from './PasswordForm';
import styles from './RLEErrorState.module.scss';
import { RLEPrivateOverlay } from './RLEPrivateOverlay';

// Values sourced from ~/controllers_v6/Next/EmbedController.php
const ERROR_ALBUM_NOT_FOUND = 404;
const ERROR_EMPTY_ALBUM = 'empty';
const ERROR_NOT_EMBEDDABLE = 'not_embeddable';
const RLE_PRIVACY_PASSWORD = 'rle_privacy_password';
const RLE_NOT_ACCESSIBLE = 'not_accessible';

const RLEErrorState = ({
  error,
  errorBackground,
  handleChange,
  handleSubmit,
  handleLogin,
  invalidPassword,
  password,
  sso,
  color,
  isOwner,
  playlistId,
}) => {
  const errorMessages = {
    deleted: translate('This event has been deleted'),
    empty: translate('This event has no videos'),
    enterPassword: translate('Enter password to watch'),
    private: translate('This is private'),
    wrongPassword: translate('Sorry, that’s not the password'),
    notEmbeddable: translate('Because of its privacy settings, this video cannot be played here.'),
  };

  let headline;
  switch (error) {
    case ERROR_ALBUM_NOT_FOUND:
      headline = errorMessages.deleted;
      break;

    case ERROR_EMPTY_ALBUM:
      headline = errorMessages.empty;
      break;

    case ERROR_NOT_EMBEDDABLE:
      headline = errorMessages.notEmbeddable;
      break;

    case RLE_PRIVACY_PASSWORD:
      headline = errorMessages.enterPassword;
      break;

    default:
      headline = errorMessages.private;
      break;
  }

  const errorBackgroundStyles = errorBackground
    ? {
        background: `linear-gradient(rgba(255,255,255,0), rgba(0,0,0,1)), url(${JSON.stringify(
          errorBackground,
        )})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }
    : null;

  return error === RLE_NOT_ACCESSIBLE ? (
    <RLEPrivateOverlay
      handleLogin={handleLogin}
      color={color}
      sso={sso}
      isOwner={isOwner}
      playlistId={playlistId}
    />
  ) : (
    <div className={styles.errorState} style={errorBackgroundStyles}>
      {error !== ERROR_NOT_EMBEDDABLE ? (
        <h1 className={styles.errorStateMessage}>{headline}</h1>
      ) : (
        <div className={styles.errorStateEmbed}>
          <h1 className={styles.errorStateEmbedTitle}>{translate('Sorry')}</h1>
          <h1 className={styles.errorStateEmbedMessage}>{headline}</h1>
        </div>
      )}
      {error === RLE_PRIVACY_PASSWORD && (
        <PasswordForm
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          invalidPassword={invalidPassword}
          password={password}
        />
      )}
    </div>
  );
};

export default RLEErrorState;
